<template>
    <span class="artist" v-if="simpleText">{{tagString == "" ? "No artist": tagString}}</span>
    <span v-else-if="displayBagdes" class="tag-badge-container" @click.prevent="onClick">
        <span v-if="tags != null" v-for="tag in tags" :key="tag.name" class="badge tag-badge">
          <span class="name">{{tag.name}}</span>
        </span>
    </span>
    <input v-else type="text" readonly placeholder="Tags" :value="tagString" :class="!tagString || tagString.length === 0 ? 'is-empty' : ''" @click.prevent="onClick"/>
</template>

<script>
    export default {
      name: "TagsBadgeList",
      props: {
        tags: Array,
        displayBagdes: { type: Boolean, default: false },
        simpleText: { type: Boolean, default: false }
      },
      computed: {
        tagString() {
          console.log(this.tags)
          if (!this.tags || this.tags.length === 0) {
            return '';
          }

          var tagsName = this.tags.map(x =>  x.name);
          return tagsName.join(', ');
        }
      },
        methods: {
        onClick(event) { this.$emit("click", event); }
      }
    }
</script>

<style scoped>
    .tag-badge-container {
        white-space: nowrap;
        text-overflow: ellipsis;
        border-bottom: 1px solid #d2d2d2;
        height: 30px;
        display: block;
    }

    .tag-badge-container:hover {
        border-bottom: 1px solid #18B9E7;
        cursor: pointer;
    }

    .tag-badge {
        background: #18B9E7;
        border-radius: 100px;
        display: -webkit-inline-box;
        display: -ms-inline-flexbox;
        display: inline-flex;
        padding: 5px 10px;
        color: white;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        margin: 0 5px;
    }

    .tag-badge.hidden {
        background: #d2d2d2;
    }

    .tag-badge .name {
        width: 100%;
        display: block;
        overflow: hidden;
        text-overflow: ellipsis;
        margin: 0 1em;
    }

    input[type=text] {
        text-overflow: ellipsis;
        cursor: pointer;
    }

    input [type=text]:focus {
        background: transparent;
    }
</style>
